import { Suspense, useState } from "react";
import styled, { css } from "styled-components";

import { Bone } from "~/src/modules/ui-kit";

import ProductContainer from "../../components/entities/product/ProductContainer";



export default function ProductCardInFinder(props) {
    const { id } = props;
    return (
        <Suspense fallback={ <ProductSkeleton /> }>
            <ProductContainer
                Component={ ProductCard }
                id={ id }
                onClick={ props.onClick }
            />
        </Suspense>
    );
}

function ProductCard(props) {
    const { archived, bimClassName, bimClassType, brandName, countries, createdAt, name, updatedAt, ...restProps } = props;
    return (
        <Styled
            $archived={ archived }
            as={ props.onClick ? "button" : "div" }
            { ...restProps }
        >
            <span className="brand">{ brandName }</span>
            <span className="name">
                { name ?? "[THIS PRODUCT DOES NOT HAVE A NAME]" }
                { archived && <span className="archived-label">[ARCHIVED]</span> }
            </span>
            <span className="bimclass">{ bimClassName }</span>
            <span className="countries">
                {
                    countries?.map?.(
                        (country) => <span key={ country }>{ country }</span>
                    )
                }
            </span>
        </Styled>
    );
}

export function ProductSkeleton() {
    const [brandSizeModifier] = useState(10 * Math.random());
    const [nameSizeModifier] = useState(20 * Math.random());
    const [bimClassSizeModifier] = useState(10 * Math.random());
    return (
        <Styled as="div" style={ { rowGap: "2px" } }>
            <Bone className="brand" height="1em" width={ 5 + brandSizeModifier + "em" } />
            <Bone className="name" height="2em" width={ 10 + nameSizeModifier + "em" } />
            <Bone className="bimclass" height="1em" width={ 5 + bimClassSizeModifier + "em" } />
        </Styled>
    );
}

const Styled = styled.button<{ $archived?: boolean }>`
    background: transparent;
    border: none;
    color: ${ ({ $archived }) => $archived ? "#d00" : "#000" };
    display: grid;
    gap: 2px 32px;
    grid-template-columns: 1fr min-content;
    grid-template-rows: min-content min-content min-content;
    padding: 4px;
    text-align: left;
    text-decoration: none;
    transition: 200ms;
    width: 100%;

    .brand {
        color: ${ ({ $archived }) => $archived ? "#d009" : "#0007" };
        font-size: .8em;
        grid-column: 1 / -1;
        white-space: nowrap;
    }

    .name {
        font-size: 1em;
        letter-spacing: 0.05em;

        .archived-label {
            color: #d00;
            font-family: var(--font-sans), sans-serif;
            font-size: .6em;
            font-weight: bold;
            margin-left: 8px;
            vertical-align: middle;
        }
    }

    .bimclass {
        align-self: end;
        font-size: .8em;
        justify-self: end;
        white-space: nowrap;
    }

    .countries {
        color: #0005;
        font-size: .8em;
        grid-column: 1 / -1;

        &:empty {
            display: none;
        }

        & > span {
            &:not(:first-child)::before {
                content: ", ";
            }
        }
    }

    ${ () => CSSClickable }
`;

const CSSClickable = css`
    cursor: pointer;

    &:hover {
        .name {
            text-decoration: underline;
        }
    }
`;

